$(document).ready(function(){
	
    if(document.querySelector('ap-badge')){
	  document.querySelector('ap-badge').shadowRoot.querySelector('a img').setAttribute('style', 'width:150px');
    }
    
    
    AOS.init({
     once: true,   
    });

    const GREEN_ARROW_RIGHT = '<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/l-arrow-m3.svg" alt="Move slider one right to next"/></div>'
    const GREEN_ARROW_LEFT = '<div class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/right-arrow-m3.svg" alt="Move slider one left to previous"/></div>'

    const WHITE_ARROW_RIGHT = '<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/l-arrow-white.svg?v=1615256803" alt="Move slider one right to next"/></div>'
    const WHITE_ARROW_LEFT = '<div class=" slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0053/3993/8880/files/w-arrow-right.svg?v=1615256803" alt="Move slider one left to previous"/></div>'


    $('.product-offer__slider .main-slider').slick({
        asNavFor: $('.product-offer__slider .nav-slider'),
        fade: true
    }) 
    $('.product-offer__slider .nav-slider').slick({
        asNavFor: $('.product-offer__slider .main-slider'),
        slidesToShow: 6,
        centerMode: false,
        focusOnSelect: true,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true
    })
     // Slider for static pages
     $('#shopify-section-m3-usp-slider .usp-slider__slider ').slick({
        // the 'SlidesToShow' is not given as a data property so does need declared here.
        slidesToShow: 4,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true,
        autoplay:true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })
    // Slider for static pages
    $('#m3-landing .usp-slider__slider').slick({
        // the 'SlidesToShow' is not given as a data property so does need declared here.
        slidesToShow: 3,
        prevArrow: WHITE_ARROW_RIGHT,
        nextArrow: WHITE_ARROW_LEFT,
        swipeToSlide: true,
        autoplay: true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })
    // Slider for dynamic #ProductLanding page. 
    $('#ProductLanding .usp-slider__slider').slick({
        // the 'SlidesToShow' is given as a data property so no need to be declared here.
        // slidesToShow: 3,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true,
        autoplay:true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })
    $('.featured-products__slider, .chair-carousel__contents').slick({
        slidesToShow: 3,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    })
    // Slider on Product template
    $('.trusted__slider').slick({
        slidesToShow: 4,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    })
    // Slider on Landing Location template
    $('.trusted-by__slider').slick({
        slidesToShow: 4,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        autoplay: true,
        autoplaySpeed: 2500,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    })

    /* Partners Slider - Static on mobile */
    $('.m3-partners__inner[data-slider]').slick({
        slidesToShow: 7,
        // prevArrow: GREEN_ARROW_RIGHT,
        // nextArrow: GREEN_ARROW_LEFT,
        autoplay: false,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 4,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    swipeToSlide: true,
                }
            }
        ]
    })

    /* USP Counters - Static on mobile */
    $('.usp-counters[data-slider]').slick({
        slidesToShow: 7,
        // prevArrow: GREEN_ARROW_RIGHT,
        // nextArrow: GREEN_ARROW_LEFT,
        autoplay: false,
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 4,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    swipeToSlide: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    swipeToSlide: true,
                }
            }
        ]
    })

    $('.treatment__slider').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint:900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint:480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    })

    $('#reviews.grid-videos-pain-point').slick({
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        mobileFirst: true,
        arrows: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 768,
                settings: 'unslick'
            }
        ]
    });

    $('.experts__slider, .testimonial__slider').slick({
        slidesToShow: 1,
        prevArrow: GREEN_ARROW_RIGHT,
        nextArrow: GREEN_ARROW_LEFT,
    })
    $('.accordion__item .heading').on('click', function(){
        var accordion = $(this).closest('.accordion')
        
        if(!$(this).hasClass('open')){
            var current_option = accordion.find(".heading.open")
            current_option.removeClass('open')
            current_option.siblings('.body').slideUp()
            $(this).addClass('open')
        }else{
            $(this).removeClass('open')
        }

        $(this).siblings('.body').slideToggle() 
 
        accordion.find('.body.in-view').removeClass('in-view')

        
        $(this).removeClass('start')
        
    })
    // Colow Swatch handler for 'product-template-v2.liquid'
    // On color swatch clicked, set the right slick slide
    $('#shopify-section-product-template-v2 .color-picker__color input').on('change', function(){
        const selected_color = $(this).attr("data-index");
        const selected_name = $(this).attr("data-name");
        const selected_variant_id = $(this).attr("data-variant-id");
        var slider_index = parseInt($('#color-'+selected_color).attr('data-slick-index'));
        $('.product-offer__slider .main-slider').slick('slickGoTo', slider_index);
        $('.color-selected').html(selected_name);
        $('.btn.atc').prop('href', '/cart/add?id='+selected_variant_id);
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + selected_variant_id;
        window.history.replaceState({path: newurl}, '', newurl);
    })

    // Color Swatch handler 'page-product-sections-template.liquid'
    // Product with sections - On color swatch clicked, set the right slick slide
    $('.color-picker__color input').on('change', function() {
        const selected_color_image_id = $(this).attr("data-image-id");
        const selected_name = $(this).attr("data-name");
        const selected_variant_id = $(this).attr("data-variant-id");
        const slider_index = $(`.slick-slide[data-image-id="${selected_color_image_id}"]`).attr('data-slick-index');

        // Slide to selected variant color image
        $('.product-offer__slider .main-slider').slick('slickGoTo', slider_index);
        $('.color-selected').html(selected_name); // Update color label shown

        // --- Monster Cart update ---
        $('.btn.atc')
            .removeAttr('href') // prevent normal navigation
            .attr('data-variant-id', selected_variant_id); // store variant ID

        // Update the page URL
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + selected_variant_id;
        window.history.replaceState({ path: newurl }, '', newurl);
    });




    $('.tech .heading').on('click', function(){
        if($(this).attr('data-image')){
            var side_image = $(this).attr('data-image')
            console.log(side_image)
            $('.tech:not(.works) .tech__image img').prop('src', side_image)
        }
    })

    /* FAQS */
    $('.faq-block').on('click', (event)=>{
        const faq_block = event.currentTarget;
        // if open, close
        if(faq_block.classList.contains('open')){
            $('.faq-answer', faq_block).slideUp();
            faq_block.classList.remove('open');
        }
        else {
            // else, open
            $('.faq-answer', faq_block).slideDown();
            faq_block.classList.add('open');
        }
        

    })

    /* Play Video on click*/
    $('.m3-custom-video .video__button-wrapper').on('click', (event)=>{
        event.preventDefault();
        const $button = event.currentTarget;
        const video = $($button).prev('video')[0];
        console.log(video)

        if(video.classList.contains('playing')){
            video.pause()
            video.classList.remove('playing')
            console.log("Play - Stop")
        }else{
            video.play();
            video.classList.add('playing')
            video.setAttribute('controls', true);
            console.log("playing")
        }
    })

    /* Counter Up */
    if(window.counterUp){
	
      const counterUp = window.counterUp.default;

      const callback = entries => {
          entries.forEach( entry => {
              const el = entry.target
              if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
                  counterUp( el, {
                      duration: 1000,
                      delay: 10,
                  } )
                  el.classList.add( 'is-visible' )
              }
          } )
      }

      const IO = new IntersectionObserver( callback, { threshold: 1 } )

      const counters = document.querySelectorAll('.counter-enabled');
      counters.forEach( (counter) => {
          IO.observe( counter );
      })
	}
    
    setTimeout(function() {
        var tablinks = $(".product-tab__links");
        var tabcontents = $(".product-tab__content");
        var slider = $('#health-benefits .usp-slider__slider');

        var bonusSlider = $('#product-features .bonus__content');
        var sliderTestimonials = $('#testimonials .usp-slider__slider');
        var sliderFeatures = $('#product-features .usp-slider__slider');

        function opentab(tabname) {
            tablinks.removeClass("active-link");
            tabcontents.removeClass("active-tab");

            $("[data-tabname='" + tabname + "']").addClass("active-link");
            $("#" + tabname).addClass("active-tab");

            slider.slick('refresh');
            sliderTestimonials.slick('refresh');
            sliderFeatures.slick('refresh');

            bonusSlider.slick('refresh');
        }

        tablinks.on("click", function() {
            var tabname = $(this).data("tabname");
            opentab(tabname);
        });

        $('.testimonial__sliders.owl-carousel').owlCarousel({
            items:1,
            margin: 10,
            loop:false,
            lazyload:true,
            center: false,
            dots: false,
            nav: true,
            responsive: {
                600: {
                    items: 2
                }
            }
        });
        
        slider.slick({
            slidesToShow: 3,
            autoplay: true,
            responsive: [
                {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1
                }
                }
            ]
        });

        sliderFeatures.slick({
            slidesToShow: 3,
            autoplay: true,
            arrow: true,
            responsive: [
                {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1
                }
                }
            ]
        });

        sliderTestimonials.slick({
            slidesToShow: 3,
            autoplay: true,
            responsive: [
                {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1
                }
                }
            ]
        });
        
        bonusSlider.slick({
            slidesToShow: 1,
            mobileFirst: true,
            autoplay: true,
            responsive: [
                {
                  breakpoint: 425,
                  settings: {
                      slidesToShow: 2
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 3
                  }
                }
            ]
        });

        $(window).on('resize', function() {
            bonusSlider.slick('resize');
        });
    }, 100);

    // accordion
    const accordionItems = document.querySelectorAll(".feature__accordion-item");
    const featureImgContainer = document.querySelector(".feature__img-container");
    
    accordionItems.forEach(item => {
        const title = item.querySelector(".feature__accordion-title");
        const content = item.querySelector(".feature__accordion-content");
        const itemId = item.id;
        const correspondingImg = featureImgContainer.querySelector(`#${itemId}`);
    
        title.addEventListener("click", function() {
            // Hide all images
            featureImgContainer.querySelectorAll("img").forEach(img => {
                img.style.display = "none";
            });
    
            // Toggle active class for the clicked accordion item
            accordionItems.forEach(accItem => {
                accItem.querySelector(".feature__accordion-content").classList.remove("active");
            });
            content.classList.add("active");
    
            // Display corresponding image if the accordion item is active
            if (content.classList.contains("active")) {
                correspondingImg.style.display = "block";
            } else {
                correspondingImg.style.display = "none";
            }
        });
    });



    $(".feature__accordion-title").click(function () {
        var clickedItem = $(this).parent();

        clickedItem.find(".feature__accordion-content").slideToggle();
        clickedItem.siblings().find(".feature__accordion-content").slideUp();
        clickedItem.closest('.feature__accordion-container').find('.feature__accordion-content').not(clickedItem.find(".feature__accordion-content")).slideUp();
        clickedItem.toggleClass("active").siblings().removeClass("active");
    });

    //product features
    $('.feature__discover-more').click(function() {
        $('.feature__accordion-container .left-container').toggle();

        var isVisible = $('.feature__accordion-container .left-container').is(':visible');
        if (isVisible) {
            $('.feature__discover-more').text('Show Less');
        } else {
            $('.feature__discover-more').text('Discover More');
        }
    });

    // read more / read less
    var paragraphCount = $('.product-description > p').length;
    $('#hider').hide();
    $('#shower').hide();
    if (paragraphCount > 3) {
        $('#shower').show();
    }
    $( '#hider' ).click(function() {
        $('.product-description p:gt(1)').hide();
        $('#hider').hide();
        $('#shower').show();
    });
    $( '#shower' ).click(function() {
        $('.product-description p').show();
        $('#shower').hide();
        $('#hider').show();
    });
    $('.product-description p:gt(1)').hide();

    $('.massage-location__contents-carousel').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
      });

    
    // new landing page js start
    $('.video-slider__contents').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30%',
        arrows: true,
        dots: true,
        autoplay: false,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    centerPadding: '20%',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 475,
                settings: {
                    centerPadding: '50px',
                }
            }
        ]
    });

    $('.marquee-bar__contents').slick({
        speed: 6000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        slidesToShow: 1,
        draggable:false,
        focusOnSelect:false,
        pauseOnFocus:false,
        pauseOnHover:false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false
    });
    $('.info-slider__content').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true
      });
      $('.usp-carousel__content').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
      });
      $('.zoho-form__carousel-contents').slick({
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        autoplay: true,
        vertical: true,
        centerPadding: "60px",
        centerMode: true,
      });
    // new landing page js end

    // masseuse-discount
    $('.video-info__contents').slick({
      slidesToShow: 3,
      autoplay: false,
      arrows: true, // Note: "arrow" should be "arrows"
      infinite: false,
      prevArrow: '.video-info__btn-prev',
      nextArrow: '.video-info__btn-next',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    
    $('.minimal-header__announcement-wrapper, .banner-marquee__announcement-wrapper').slick({
        speed: 15000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: false,
        cssEase: 'linear',
        slidesToShow: 1,
        draggable:false,
        focusOnSelect:false,
        pauseOnFocus:false,
        pauseOnHover:false,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 5,
        arrows: false,
        buttons: false
      });

      // ndis start
    document.querySelectorAll(".accordion__content").forEach((accordionContent) => {
        // Open the first item in each .accordion__content
        const firstAccordion = accordionContent.querySelector(".accordion-item__title");
        if (firstAccordion) {
            firstAccordion.classList.add("open");
            const firstContent = firstAccordion.nextElementSibling;
            if (firstContent) {
                firstContent.style.display = "block";
            }
        }
    
        // Add click event listeners to toggle items
        const menuBtns = accordionContent.querySelectorAll(".accordion-item__title");
        menuBtns.forEach((menuBtn) => {
            menuBtn.addEventListener("click", function () {
                // Close other open accordions in the same container
                const activeAccordion = accordionContent.querySelector(".accordion-item__title.open");
                if (activeAccordion && activeAccordion !== this) {
                    activeAccordion.classList.remove("open");
                    activeAccordion.nextElementSibling.style.display = "none";
                }
    
                // Toggle the clicked accordion
                this.classList.toggle("open");
                const content = this.nextElementSibling;
                if (this.classList.contains("open")) {
                    content.style.display = "block";
                } else {
                    content.style.display = "none";
                }
            });
        });
    });

    $('.product-slider__contents-js').slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    
    // ndis end

    // rilasante start
    $('.relief-slider__contents').slick({
      slidesToShow: 4,
      autoplay: false,
      arrows: true, // Note: "arrow" should be "arrows"
      infinite: false,
      prevArrow: '.relief-slider__btn-prev',
      nextArrow: '.relief-slider__btn-next',
      responsive: [
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    // rilasante end

    // new product offer js start

    // new product offer js end

    $('.review-slider__contents.review-unslick').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 581,
                settings: 'unslick'
            },
        ]
    });

    $('.review-slider__contents.review-slick').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 525,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}) 

$(document).ready(function () {
  const $mainSlider = $('.product-offer__slider .main-slider');
  const $navSlider = $('.product-offer__slider .nav-slider');

  function buildSliders(selected_color_variant, selected_name, selected_variant_id) {
    // Destroy slicks if initialized
    if ($mainSlider.hasClass('slick-initialized')) $mainSlider.slick('unslick');
    if ($navSlider.hasClass('slick-initialized')) $navSlider.slick('unslick');

    // Get matching items from reference
    const $referenceItems = $('.reference-slider .item');
    const $filteredItems = $referenceItems.filter(`[data-color-variant="${selected_color_variant}"]`);

    // Clear and rebuild sliders
    $mainSlider.empty();
    $navSlider.empty();

    $filteredItems.each(function () {
      const imgSrc = $(this).data('image-source');
      const imgId = $(this).data('image-id');
      const colorVariant = $(this).data('color-variant');

      $mainSlider.append(`
        <div class="item" data-image-id="${imgId}" data-color-variant="${colorVariant}">
          <div><img src="${imgSrc}" alt="" /></div>
        </div>
      `);

      $navSlider.append(`
        <div class="item" data-image-id="${imgId}" data-color-variant="${colorVariant}">
          <div><img src="${imgSrc}" alt="" width="100px" height="100%" /></div>
        </div>
      `);
    });

    // Count items in nav-slider and add a class like slides-4
    const navCount = $navSlider.children('.item').length;
    $navSlider
      .removeClass(function (i, c) {
        return (c.match(/(^|\s)slides-\S+/g) || []).join(' ');
      })
      .addClass(`slides-${navCount}`);

    // Reinit slick
    $mainSlider.slick({
      asNavFor: '.product-offer__slider .nav-slider',
      fade: true,
      infinite: false,
    });
    $navSlider.slick({
      asNavFor: '.product-offer__slider .main-slider',
      slidesToShow: 5,
      centerMode: false,
      focusOnSelect: true,
      infinite: false,
      swipeToSlide: true
    });

    // Update UI
    if (selected_name) $('.color-selected').html(selected_name);
    if (selected_variant_id) {
        // Store the variant ID for later use by Monster Cart JS
        $('.btn.atc').attr('data-variant-id', selected_variant_id);

        // Remove any cart href to prevent page navigation
        $('.btn.atc').removeAttr('href');

        // Update the page URL to reflect the selected variant
        const newurl =
            window.location.protocol +
            '//' +
            window.location.host +
            window.location.pathname +
            '?variant=' +
            selected_variant_id;
        window.history.replaceState({ path: newurl }, '', newurl);
    }
  }

  // Handle swatch clicks
  $('.product-thera-dual-pro-new .color-picker__color input').on('change', function () {
    const selected_color_variant = $(this).data("color-variant");
    const selected_name = $(this).data("name");
    const selected_variant_id = $(this).data("variant-id");

    buildSliders(selected_color_variant, selected_name, selected_variant_id);
  });

  // On page load, auto-build sliders for the first checked swatch
  const $defaultSwatch = $('.product-thera-dual-pro-new .color-picker__color input:checked').first();
  if ($defaultSwatch.length) {
    buildSliders(
      $defaultSwatch.data("color-variant"),
      $defaultSwatch.data("name"),
      $defaultSwatch.data("variant-id")
    );
  }
});

$(document).on('click', '.btn.atc', async function (e) {
  e.preventDefault();

  const variantId = $(this).attr('data-variant-id');
  if (!variantId) {
    console.warn('No variant ID found for add to cart');
    return;
  }

  try {
    // Add product to cart (AJAX)
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    // Open Monster Cart
    if (typeof monster_refresh === 'function') monster_refresh();
    if (typeof openCart === 'function') openCart();

  } catch (err) {
    console.error('Add to cart failed:', err);
  }
});
